import * as React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { useResource, Resources } from "Translations/Resources";
import { RecentActivities } from "Components/Shared/Icons/RecentActivities";

type Props = {};

const StyledNoActivitiesTitle = styled(Typography)`
  font-size: 22px;
  font-weight: 300;
  text-align: center;
  padding-bottom: ${props => props.theme.spacing(1)}px;
`;

const StyledNoActivitiesText = styled(Typography)`
  text-align: center;
  color: ${props => props.theme.palette.secondary.main};
`;

const StyledIcon = styled.div`
  padding: ${props => props.theme.spacing(0, 2)};
  padding-bottom: ${props => props.theme.spacing(2)}px;
  svg {
    width: 100%;
    height: auto;
  }
`;

export const NoRecentActivities: React.FunctionComponent<Props> = props => {
  const { t } = useResource();
  return (
    <div>
      <StyledIcon>
        <RecentActivities />
      </StyledIcon>

      <StyledNoActivitiesTitle>
        {t(Resources.Dashboard.RecentActivities.NoActivities.Title)}
      </StyledNoActivitiesTitle>

      <StyledNoActivitiesText>
        {t(Resources.Dashboard.RecentActivities.NoActivities.Text)}
      </StyledNoActivitiesText>
    </div>
  );
};
